import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { SmsPolicy } from './pages/SmsPolicy';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
        <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-6" />} data-id="element-5" />
        <Route path="/sms-policy" element={<SmsPolicy data-id="element-8" />} data-id="element-7" />
      </Routes>
    </BrowserRouter>;
}